import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { saveForLater } from '../util/apiUtils';
import ConnectRememberMe from '../phsycian-in-the-loop/rememberMeUtil';

/**
 * Component to remove a requisition from an order.
 */
class RemoveRequisition extends Component {
	
	/**
	 * Constructor binds component functions.
	 */
	constructor(props) {
		super(props);
		
		this.removeRequisition = this.removeRequisition.bind(this);

		this.state = {
			inProgress: false
		}
	}
	
	/**
	 * Show the modal when the component mounts.
	 */
	componentDidMount() {
		window.$(ReactDOM.findDOMNode(this)).modal("show");
		window.$(ReactDOM.findDOMNode(this)).on("hidden.bs.modal", this.props.modalHidden)
		// bootstrap puts a blur on ".modal-open .page-wrapper" and recommends placing modals in a top-level to prevent
		// other CSS from affecting the modal appearance. We can't do this though, because the react root is nested
		// pretty deep in the wrapping DOM, so instead we're programatically dropping the blurry styles
		window.$(".page-wrapper").css({
			"filter": "none",
			"-webkit-filter": "none",
			"-moz-filter": "none",
			"-o-filter": "none",
			"-ms-filter": "none"
		});

		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}
	
	/**
	 * Removes the requisition from the order.
	 */
	removeRequisition() {
		this.setState({ inProgress: true });

		if (this.props.saveForLater) {
			this.saveForLater();
		} else {
			let gearRequisitionId = this.getGearRequisitionId(this.props.requisition);
			fetch(process.env.REACT_APP_GEAR_REST_URL + "/order/" + this.props.gearOrderId + "/requisition/" + gearRequisitionId, {
				method: "DELETE",
				mode: "cors",
				credentials: "include",
				timeout: 1000,
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				}
			})
				.then((response) => {
					this.props.removeRequisitionResponseHandler(response);
				}).then(() => {
					if (this.props.requisition.physicianInTheLoop && !(this.props.requisitionCount > 1)) {
						ConnectRememberMe.clear();
						window.location.href = 'https://connect.gdx.net'
					}
			})
				.catch(error => {
					//TODO: need to show error in parent components
					console.log(error);
				});
		}
	}

	/**
	 * Duplicate the GearOrder and move the requisition to the new order.
	 */
	saveForLater = () => {
		this.setState({ inProgress: true });

		// Turn off close on click-outside while the request is in progress
		if (this._isMounted) {
			const modalData = window.$(ReactDOM.findDOMNode(this)).data('bs.modal');
			if (modalData) {
				modalData.options.backdrop = 'static';
				modalData.options.keyboard = false;
			}
		}
		
		let gearRequisitionId = this.getGearRequisitionId(this.props.requisition);

		saveForLater(this.props.gearOrderId, gearRequisitionId, this.props.queryString)
			.then((gearOrder) => {
				/*
				 * removeRequisitionResponseHandler handles the delete OR saveForLater. 
				 * The delete passes the raw response and the caller evaluates the response status and calls json().then() to get the order JSON.
				 * Mock a response with a 'status' and 'json()' method so the caller can handle both responses the same.
				 */
				const mockResponse = {
					status: 200,
					json: function () {
						return new Promise((resolve, reject) => {
							resolve(gearOrder);
						});
					}
				};
				this.props.removeRequisitionResponseHandler(mockResponse);
			})
			.catch((error) => {
				console.log(error);
				this.props.removeRequisitionResponseHandler({ status: 500, error: error });
			})
			.finally(() => {
				this.setState({ inProgress: false });
				if (this._isMounted) {
					window.$(ReactDOM.findDOMNode(this)).off('hide.bs.modal'); //`off` to remove event handler attached with `on`
					window.$(ReactDOM.findDOMNode(this)).modal('hide'); // hide modal
				}
			});
	}

	/**
	 * Get the ID of the Gear Requisition.
	 * 
	 * The requisition could be a RequisitionHistoryEntry (passed in from HistoryItemRequisition) or a 
	 * GearRequisition (passed in from the shopping cart or confirmation step). Those two objects have a different
	 * attribute for the gear req id. Use the one available.
	 */
	getGearRequisitionId = (requisition) => {
		return this.props.requisition.gearRequisitionId || this.props.requisition.id;
	}

	getModalBody = (requisition, saveForLater) => {
		if (saveForLater) {
			return (
				<>
					<p className="bold">
						{this.props.requisition.reqNumber} - {this.props.requisition.omsOrderableItemName}
					</p>
					<p>Would you like to save this requisition for later?</p>
					<p>
						We will save all information and you will be able to continue activation at any time by visiting{' '}
						<a href="/activate" target="_blank">
							gdx.net/activate
						</a>
						.
					</p>
				</>
			);
		} else if (this.props.requisition.physicianInTheLoop && !(this.props.requisitionCount > 1)) {
			return (
					<p>
						Are you sure you want to cancel this order? All your progress will be lost and you will be redirected to <b>connect.gdx.net</b>
					</p>
			);
		} else {
			return (
				<p>
					Remove requisition {requisition.reqNumber || ''} {requisition.omsOrderableItemName} from this order?
				</p>
			);
		}
	}
	
	/**
	 * Renders the delete requisition modal component.
	 */
	render() {
		let modalTitle = this.props.saveForLater ? 'Save for Later' : 'Remove Requisition';
		const modalBody = this.getModalBody(this.props.requisition, this.props.saveForLater);

		if (this.props.requisition.physicianInTheLoop && !(this.props.requisitionCount > 1)) { 
			modalTitle = 'Cancel Order';
		}

		return (
			<div className="modal fade" id="deleteRequisitionModal" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
					{this.state.inProgress && (
						<div className="loading-shield" style={{ position: 'absolute', zIndex: '90' }}>
							<i
								className="fa fa-spinner fa-spin fa-fw loading-icon"
								style={{ width: '1em', position: 'absolute' }}
							></i>
						</div>
					)}
						<div className="modal-header">
							<button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 className="modal-title">{modalTitle}</h4>
						</div>
						<div className="modal-body">
							{modalBody}
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-primary"
								data-bs-dismiss={!this.props.saveForLater ? "modal" : null}
								onClick={this.removeRequisition}
							>
								Yes
							</button>
							<button type="button" className="btn btn-light" data-bs-dismiss="modal">
								No
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

export default RemoveRequisition;
